import { Column } from '../types';
import { ColumnIds } from '../constants';
import { valueToLabelMap } from './valueToLabelMap';

const normalizeRows = (items: any[], columns: Column[]): any[] => {
  const columnIds = new Set(columns?.map(col => col.id));

  const normalizedRows = items.map((row: any) => {
    const normalizedRow: any = {};
    Object.entries(row).forEach(([key, value]: [string, any]) => {
      if (value && typeof value === 'object') {
        if (key === ColumnIds.AccreditationOrganization) {
          normalizedRow[key] = value.name;
          return;
        }
        if (
          key === ColumnIds.Role ||
          key === ColumnIds.RegistrationStatus ||
          key === ColumnIds.SubCategory
        ) {
          normalizedRow[key] = value.value;
          return;
        }
      }
      normalizedRow[key] = value;
      if (key === ColumnIds.DateOfBirth) {
        const date = new Date(value);
        normalizedRow[key] = value
          ? date.toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            })
          : '';
        return;
      }
    });
    return normalizedRow;
  });

  return normalizedRows.map((row: any) => {
    const filtered: any = { id: row.id };
    columnIds.forEach(colId => {
      if (colId in row) {
        filtered[colId] = valueToLabelMap[colId]?.[row[colId]] ?? row[colId];
      }
    });
    return filtered;
  });
};

export { normalizeRows };
